import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';
import { Link, useLocation } from 'react-router-dom';

import SVG from 'components/SVG';
import { actions } from 'features/app';
import { sideMenuItems } from './data';
import './SideMenu.scss';
import { getLocalizedByRole } from 'shared/utils/roleBasedLocale';

const b = block('side-menu');

const SideMenu = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const activeRequestsCount = useSelector(state => state.transaction.activeRequests?.items?.length ?? 0);
  const role = useSelector(state => state.auth.role);
  const location = useLocation();

  const dispatch = useDispatch();

  const handleItemClick = () => {
    dispatch(actions.changeSideMenuOpened(false));
  };

  const blocks = sideMenuItems.map((itemsData, i) => {
    const items = itemsData
       .filter(item => {
        return !(item.roles && item.roles.length > 0 && !item.roles.includes(role));
      })
      .map(item => {
        const isActiveRequests = item.text === 'activeRequests';

        let badge = null;
        if (isActiveRequests) {
          badge = <span className={b('badge', {})}>{`+${activeRequestsCount}`}</span>;
        }

        const roleLocale = getLocalizedByRole(role);

        const itemText = item.text === 'users' ? locale[roleLocale] : locale[item.text] ?? item.text;
        const isActive = location.pathname.startsWith(item.link);

        return (
          <Link
            className={b('item', { badge: isActiveRequests, isActive })}
            to={item.link}
            key={item.text}
            onClick={handleItemClick}>
            <div className={b('left')}>
              <SVG svgProps={{ svg: item.icon }} className={b('item-icon')} />
              {itemText}
            </div>
            <div className={b('right')}>
              {badge}
              {item.additional && (
                <Link className={b('item-additional')} to={item.additional?.link ?? '#'}>
                  <SVG svgProps={{ svg: item.additional?.icon }} className={b('item-icon')} />
                </Link>
              )}
            </div>
          </Link>
        );
      });

    return (
      <div className={b('block')} key={`block_${i}`}>
        {items}
      </div>
    );
  });

  return <div className={b()}>{blocks}</div>;
};

export default SideMenu;
